module.exports = __webpack_public_path__ + "static/media/login-logo.703b337e.png";